export const ALLOCATION_FIELD = "roleAllocations";

export enum CHANGE_TYPE {
  ADD = "Created",
  MOD = "Updated",
  DEL = "Deleted",
}

export enum FIELD_TYPE {
  roleAllocations = "Allocations",
  teamLeadMappings = "Team Lead",
  genericRole = "Standard Role",
}
